// extracted by css-extract-rspack-plugin
export default {"formVariables":"aoOefySCX0wh8jBE"};